import React from "react";
import {
  Modal, Box, Typography, TextField, Button
} from "@mui/material";

const EditEventModal = ({ open, onClose, onSave, onDelete, eventData, setEventData }) => {
  const handleChange = (field, value) => {
    setEventData((prev) => ({
      ...prev,
      [field]: new Date(value),
    }));
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="edit-event-modal">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 450,
          backgroundColor: "white",
          padding: 4,
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Edit Event
        </Typography>

        <TextField
          fullWidth
          label="Event Title"
          value={eventData?.title || ""}
          onChange={(e) =>
            setEventData((prev) => ({ ...prev, title: e.target.value }))
          }
          sx={{ mb: 2 }}
        />

        {/* Read-only text display for start and end times */}
        <Typography variant="body2" sx={{ mb: 1 }}>
          Current Start Time: {eventData?.start ? new Date(eventData.start).toLocaleString() : "N/A"}
        </Typography>
        <TextField
          fullWidth
          type="datetime-local"
          label="Update Start Time"
          onChange={(e) => handleChange("start", e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        />

        <Typography variant="body2" sx={{ mb: 1 }}>
          Current End Time: {eventData?.end ? new Date(eventData.end).toLocaleString() : "N/A"}
        </Typography>
        <TextField
          fullWidth
          type="datetime-local"
          label="Update End Time"
          onChange={(e) => handleChange("end", e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          multiline
          minRows={3}
          label="Description / Meeting Info"
          value={eventData?.description || ""}
          onChange={(e) =>
            setEventData((prev) => ({ ...prev, description: e.target.value }))
          }
          sx={{ mb: 2 }}
        />

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Created By: {eventData?.created_by_user_id || "N/A"}
        </Typography>

        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={onSave}
          >
            Save Changes
          </Button>
          <Button
            fullWidth
            variant="outlined"
            color="error"
            onClick={onDelete}
          >
            Delete Event
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditEventModal;
